import pick from 'lodash/pick';
import get from 'lodash/get';
import { SlotType } from '@rome/response/page/v4/SlotType';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import { InlineMessageCTA } from 'typings/MiscWidgetTypes';
import * as actions from 'actions/pageActionsV4';
import { BrowsePages } from 'constants/pageTypes';
const { PAGE_DATA_ACTIONS } = actions;
export function extractMetada(slots, pathname, search, pageNumber, action) {
    const n = slots.length;
    const output = {
        adProducts: [],
        seoPagination: {},
        productList: []
    };
    let searchBrowseItemListSchema = [];
    for (let i = 0; i < n; i++) {
        const slot = slots[i];
        // proceed further only when the slot is an actual widget
        if (slot.slotType !== SlotType.WIDGET) {
            continue;
        }
        const widgetType = get(slot, 'widget.type');
        switch (widgetType) {
            /**
             * 1. extract ads info from products
             * 2. analytics data from first product
             * 2. extract PIDs
             */
            case WidgetTypeV4.PRODUCT_SUMMARY:
                const productSummaryData = get(slot, 'widget.data');
                // proceed further only if products are present
                if (!productSummaryData.products || productSummaryData.products.length === 0)
                    continue;
                const m = productSummaryData.products.length;
                if (!output.viewType) {
                    output.viewType = get(slot, 'widget.viewType');
                }
                // collect required info from all the products
                for (let j = 0; j < m; j++) {
                    const product = productSummaryData.products[j];
                    if (__SERVER__ && pageNumber === 1 && searchBrowseItemListSchema.length < 10 && product.productInfo.action) {
                        searchBrowseItemListSchema.push({
                            '@type': 'ListItem',
                            position: searchBrowseItemListSchema.length + 1,
                            url: `https://www.flipkart.com${product.productInfo.action.url}`,
                            name: get(product.productInfo.value, 'titles.title')
                        });
                    }
                    // set productAnalyticsData only if it is not set
                    // this will ensure, we pick data from first product
                    if (!output.productAnalyticsData) {
                        output.productAnalyticsData = get(product, 'productInfo.value.analyticsData');
                    }
                    output.productList.push(get(product, 'productInfo.value.id'));
                    if (product.adInfo) {
                        output.adProducts.push(pick(product.adInfo, ['bannerId', 'impressionId', 'responseId']));
                    }
                }
                continue;
            case WidgetTypeV4.EMPTY_SEARCH:
                output.totalProducts = 0;
                output.currentCount = 0;
                output.q = get(slot, 'widget.data.query', '');
                continue;
            /**
             * 1. Extract query from FILTER_SORT_OPTIONS
             */
            case WidgetTypeV4.FILTER_SORT_OPTIONS:
                output.q = get(slot, 'widget.data.augment.value.title', '') || get(slot, 'widget.data.query', '');
                output.totalProducts = get(slot, 'widget.data.totalProducts', 0);
                output.currentCount =
                    get(slot, 'widget.data.productEndIndex', 0) - get(slot, 'widget.data.productStartIndex', 0) + 1;
                output.isAugmented = !!get(slot, 'widget.data.augment');
                output.breadcrumbsData = get(slot, 'widget.data.breadCrumbs');
                continue;
            case WidgetTypeV4.INLINE_MESSAGE:
                const widgetSlot = slot;
                if (typeof widgetSlot.widget === 'undefined') {
                    continue;
                }
                const widgetTracking = widgetSlot.widget.tracking || {};
                const { clickToAction } = widgetTracking;
                switch (clickToAction) {
                    case InlineMessageCTA.QUERY_CORRECTED:
                    case InlineMessageCTA.SPELL_SUGGESTION:
                        const { contentType, position } = widgetTracking;
                        output.searchAugmentationWidgetShownValue = `UM_${contentType}_shown_${clickToAction}_${position}`;
                        break;
                    default:
                        break;
                }
                continue;
            /**
             * Get Next and Prev page links from PAGINATION_BAR
             */
            case WidgetTypeV4.PAGINATION_BAR:
                const paginationBarData = get(slot, 'widget.data');
                const { currentPage, totalPages } = paginationBarData;
                if (typeof currentPage !== 'number' || typeof totalPages !== 'number')
                    continue;
                const searchParams = new URLSearchParams(search);
                if (currentPage > 1) {
                    /**
                     * previous url must not have page=1 query param
                     * https://www.contentkingapp.com/academy/pagination/
                     */
                    const prevPage = currentPage - 1;
                    if (prevPage > 1) {
                        searchParams.set('page', `${prevPage}`);
                    }
                    else {
                        searchParams.delete('page');
                    }
                    output.seoPagination.prevUrl = `${pathname}?${searchParams}`;
                }
                if (currentPage < totalPages) {
                    searchParams.set('page', `${currentPage + 1}`);
                    output.seoPagination.nextUrl = `${pathname}?${searchParams}`;
                }
                continue;
            case WidgetTypeV4.FILTERS:
                output.storeMetaInfo = get(slot, 'widget.data.filters.facetResponse.parentMetaInfoList');
                continue;
            case WidgetTypeV4.ANNOUNCEMENT:
                output.hasAnnoucement = true;
                continue;
            default:
                continue;
        }
    }
    if (__SERVER__ && searchBrowseItemListSchema.length) {
        output.seoSchema = {
            '@context': 'http://schema.org',
            '@type': 'ItemList',
            itemListElement: searchBrowseItemListSchema
        };
    }
    output.sqid = action.sqid;
    output.ssid = action.ssid;
    return output;
}
export const initialState = {};
export default function (state = initialState, action) {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.SUCCESS:
            const slots = get(action, 'data.slots');
            if (!slots)
                return state;
            if (action.pageType && BrowsePages.indexOf(action.pageType) !== -1) {
                return extractMetada(slots, get(action, 'location.pathname', ''), get(action, 'location.search', ''), get(action.requestContext, 'pageContext.pageNumber') || 1, action);
            }
            return initialState;
        case PAGE_DATA_ACTIONS.REQUEST:
        case PAGE_DATA_ACTIONS.ERROR:
        case PAGE_DATA_ACTIONS.CLEAR:
            return initialState;
        default:
            return state;
    }
}
